// ===================================================================
// CONFIGURAÇÃO DA COMUNICAÇÃO DE ALTERAÇÃO DE LOGIN NO SINIR (GR-564)
// ===================================================================
// Pop-up exibido para geradores externos com credencial ativa do órgão
// Sinir, na primeira página carregada após o login, até 31/07/2026.
// Some automaticamente após essa data (sem necessidade de novo deploy).
// ===================================================================

export const SINIR_ANNOUNCEMENT_END_DATE = new Date(2026, 6, 31); // 31/07/2026

export const SINIR_SUPPORT_PHONE = '+55 11 93622-8568';
export const SINIR_SUPPORT_EMAIL = 'suporte@musa.co';
export const SINIR_INFO_URL =
  'https://www.sinir.gov.br/informacoes/comunicados/comunicado-acesso-ao-sistema-mtr-via-login-unico-gov-br/';

/**
 * Verifica se a comunicação de alteração de login no Sinir ainda está ativa
 * (hoje <= 31/07/2026, comparação por data, sem hora).
 */
export const isSinirAnnouncementActive = (): boolean => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const end = new Date(
    SINIR_ANNOUNCEMENT_END_DATE.getFullYear(),
    SINIR_ANNOUNCEMENT_END_DATE.getMonth(),
    SINIR_ANNOUNCEMENT_END_DATE.getDate(),
  );
  return today <= end;
};
